export default "__VITE_ASSET__CuIgYCsI__"